/* iArena "Купи сега": adds the product to the cart and opens the cart page at the delivery step
   (courier → office → checkout) instead of Shopify's dynamic checkout, which skips that step. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ar-buy-now');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form'); if (!form || btn.disabled) return;
    var body = new URLSearchParams(new FormData(form));
    btn.disabled = true; btn.classList.add('is-busy');
    document.querySelectorAll('.warning').forEach(function (w) { w.remove(); });
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin', body: body,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) throw res.j;
      location.href = (btn.dataset.cartUrl || '/cart') + '#ar-courier';
    }).catch(function (err) {
      btn.disabled = false; btn.classList.remove('is-busy');
      var p = document.createElement('p'); p.className = 'warning animated bounceIn';
      p.textContent = (err && (err.description || err.message)) || 'Продуктът не можа да бъде добавен.';
      form.parentNode.insertBefore(p, form.nextSibling);
    });
  });
})();
